import type { ChromeCopy } from '../types/chrome';

export const chromeDe: ChromeCopy = {
  siteMeta: {
    defaultTitle: 'SafestMenu - QR-Code-Speisekarten für Restaurants | safestmenu.com',
    defaultDescription:
      'Erstellen Sie mit SafestMenu auf safestmenu.com in Minuten eine digitale, mehrsprachige QR-Code-Speisekarte. Preise sofort ändern. Kostenlos starten.',
  },
  header: {
    homeAriaLabel: 'SafestMenu Startseite',
    mainNavAriaLabel: 'Hauptnavigation',
    mobileNavAriaLabel: 'Mobile Navigation',
    nav: {
      why: 'Warum SafestMenu',
      howItWorks: 'So funktioniert es',
      aboutUs: 'Über uns',
    },
    ctaLabel: 'App öffnen',
    openMenuAriaLabel: 'Menü öffnen',
    closeMenuAriaLabel: 'Menü schließen',
  },
  footer: {
    tagline:
      'Die QR-Code-Speisekarte für Restaurants, Cafés und Bars. Einfach eingerichtet, sicher für Ihre Gäste, schonend für die Natur.',
    siteNavAriaLabel: 'Website',
    legalNavAriaLabel: 'Rechtliches',
    exploreHeading: 'Entdecken',
    companyHeading: 'Unternehmen',
    nav: {
      why: 'Warum SafestMenu',
      howItWorks: 'So funktioniert es',
      allergenGuide: 'EU-Allergenleitfaden',
      blog: 'Blog',
      openApp: 'App öffnen',
      aboutUs: 'Über uns',
      impressum: 'Impressum',
      terms: 'AGB',
      transfactorDev: 'transfactor.dev',
    },
    craftedBy: 'Entwickelt von',
    copyrightSuffix: 'SafestMenu. Alle Rechte vorbehalten.',
  },
  consent: {
    message:
      'Wir verwenden Cookies für Analysen und zur Messung der Werbewirkung. Sie können zustimmen oder ablehnen - die Website funktioniert in beiden Fällen gleich. Wir verwenden sie nicht zur Personalisierung von Werbung.',
    decline: 'Ablehnen',
    accept: 'Akzeptieren',
    settings: 'Cookie-Einstellungen',
  },
  languageSwitcher: {
    label: 'Sprache ändern',
  },
  localeSuggestion: {
    message: 'Diese Seite ist auch auf Deutsch verfügbar.',
    accept: 'Auf Deutsch ansehen',
    dismiss: 'Nein, danke',
  },
  emailCapture: {
    defaultTitle: 'Tipps rund um Speisekarten in Ihr Postfach',
    defaultDescription:
      'Gelegentliche, praktische Tipps zu Speisekarten, Allergenen und papierlosem Restaurantbetrieb. Kein Spam.',
    defaultPlaceholder: 'you@restaurant.com',
    defaultButtonLabel: 'Abonnieren',
    emailLabel: 'E-Mail-Adresse',
    loadingButtonLabel: 'Wird abonniert…',
    successMessage:
      'Sie sind dabei. Halten Sie Ausschau nach Speisekarten-Tipps in Ihrem Postfach.',
    errorMessage: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es gleich noch einmal.',
  },
  qrPlate: {
    linkAriaLabel: 'Scannen oder tippen, um die Live-Demo-Speisekarte von SafestMenu zu öffnen',
    svgAriaLabelPrefix: 'QR-Code, der zu ',
    caption: 'Scannen oder klicken - er ist echt',
  },
  notFound: {
    seoTitle: 'Seite nicht gefunden',
    heading: 'Dieses Gericht steht nicht auf der Speisekarte.',
    message: 'Die gesuchte Seite existiert nicht oder wurde verschoben.',
    backLabel: 'Zurück zur Speisekarte',
  },
  blog: {
    seoTitle: 'Blog',
    seoDescription:
      'Praktische Tipps zu QR-Speisekarten, Gästeerlebnis und papierlosem Restaurantbetrieb.',
    eyebrow: 'Blog',
    heading: 'Notizen zu Speisekarten, Gästen und papierlosem Restaurantbetrieb.',
    emptyMessage: 'Neue Beiträge sind unterwegs.',
  },
};
